module.exports = __webpack_public_path__ + "static/media/press12.9b920038.png";